import { Alert } from '../Alert/Alert';
import { Button } from '../Button';
import { TextField } from '../TextField/Textfield';
import { ReEnableFormProps } from './types';
import classes from './SSOSettings.module.css';

export const ReEnableForm = ({
  formErrors,
  isEnabling,
  onSubmit,
  onCancel,
  isFieldRequired,
  t,
}: ReEnableFormProps) => (
  <div className={classes.formSection}>
    <div className={classes.formHeader}>
      <h3>{t('ssoSettings.reEnable.title', { defaultValue: 'Reaktiver SSO-tilkobling' })}</h3>
      <p className={classes.formDescription}>
        {t('ssoSettings.reEnable.description', { defaultValue: 'Du kan reaktivere tilkoblingen uten å fylle inn credentials på nytt, eller oppdatere dem hvis nødvendig.' })}
      </p>
    </div>

    <Alert variant="info" size="sm" title={t('ssoSettings.reEnable.tip', { defaultValue: 'Tips' })} className={classes.formTip}>
      {t('ssoSettings.reEnable.tipDescription', { defaultValue: 'Alle feltene er valgfrie. La dem stå tomme for å beholde eksisterende credentials.' })}
    </Alert>

    <form onSubmit={onSubmit} className={classes.form}>
      <TextField
        label={t('ssoSettings.form.tenantId.label')}
        name="entraIdTenantId"
        type="text"
        placeholder={t('ssoSettings.form.tenantId.placeholder')}
        error={formErrors.entraIdTenantId}
        required={isFieldRequired('entraIdTenantId')}
        description={t('ssoSettings.form.tenantId.description', { defaultValue: 'La stå tom for å beholde eksisterende' })}
      />
      <TextField
        label={t('ssoSettings.form.clientId.label')}
        name="entraIdClientId"
        type="text"
        placeholder={t('ssoSettings.form.clientId.placeholder')}
        error={formErrors.entraIdClientId}
        required={isFieldRequired('entraIdClientId')}
        description={t('ssoSettings.form.clientId.description', { defaultValue: 'La stå tom for å beholde eksisterende' })}
      />
      <TextField
        label={t('ssoSettings.form.clientSecret.label')}
        name="entraIdClientSecret"
        type="password"
        autoComplete="new-password"
        placeholder={t('ssoSettings.form.clientSecret.placeholder')}
        error={formErrors.entraIdClientSecret}
        required={isFieldRequired('entraIdClientSecret')}
        description={t('ssoSettings.form.clientSecret.description', { defaultValue: 'La stå tom for å beholde eksisterende' })}
      />
      <TextField
        label={t('ssoSettings.form.domain.label')}
        name="entraIdDomain"
        type="text"
        placeholder={t('ssoSettings.form.domain.placeholder')}
        error={formErrors.entraIdDomain}
      />

      <div className={classes.formActions}>
        <Button variant="success" size="medium" type="submit" disabled={isEnabling}>
          {isEnabling ? (
            <span className={classes.buttonLoading}>
              <span className={classes.buttonSpinner} />
              {t('ssoSettings.form.enabling')}
            </span>
          ) : (
            t('ssoSettings.activeConnections.reEnableButton')
          )}
        </Button>
        <Button variant="secondary" size="medium" onClick={onCancel} disabled={isEnabling}>
          {t('ssoSettings.form.cancelButton')}
        </Button>
      </div>
    </form>
  </div>
);
